var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNafInsuranceHomeUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 120,
    viewBox: "0 0 130 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10001_9852)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 120,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.046 114.455C123.046 117.518 96.9438 119.998 64.74 119.998C32.5363 119.998 6.43359 117.516 6.43359 114.455C6.43359 111.395 32.5383 108.913 64.74 108.913C96.9418 108.913 123.046 111.395 123.046 114.455Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7523 23.8639C93.0212 23.2571 91.9575 23.3227 91.3846 24.0094L22.0916 107.137C19.6561 110.06 15.2923 110.458 12.3639 108.027C9.43558 105.596 9.03719 101.24 11.4727 98.3171L12.6473 96.9089C13.2572 96.1771 13.1566 95.0907 12.4235 94.4819C11.6904 93.8731 10.602 93.9735 9.99209 94.7053L8.81746 96.1156C5.17241 100.488 5.7741 107.041 10.1543 110.679C14.5345 114.318 21.0997 113.717 24.7448 109.345L94.0398 26.215C94.6127 25.5283 94.4834 24.4706 93.7523 23.8639Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1297 26.914C57.2995 -1.18482 16.7974 -8.28536 0.674957 11.0587C0.531208 11.2309 0.407995 11.4154 0.272461 11.5917L0.473709 11.7597C4.91143 12.9343 9.72701 15.4248 14.1688 19.1145C18.6086 22.8021 21.9395 27.078 23.9027 31.2186C24.0177 31.4646 24.1203 31.7105 24.2251 31.9545C25.3073 29.8124 26.6236 27.779 28.2007 25.887C42.1382 9.16673 70.3129 9.62589 91.1297 26.914Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1299 26.914C111.949 44.2042 117.522 71.7741 103.585 88.4965C102.01 90.3864 100.246 92.0467 98.3358 93.498C98.5904 93.5533 98.843 93.6066 99.1018 93.6743C103.539 94.8488 108.357 97.3414 112.799 101.029C117.239 104.717 120.57 108.993 122.533 113.133L122.746 113.311C122.892 113.143 123.052 112.99 123.196 112.82C139.321 93.4754 124.962 55.0128 91.1299 26.914Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9171 52.514C49.2087 52.5796 49.4941 52.6391 49.7899 52.717C54.2255 53.8915 59.0432 56.382 63.4829 60.0696C67.9227 63.7573 71.2536 68.0332 73.2168 72.1738C73.3461 72.4485 73.457 72.719 73.5741 72.9917C73.5802 72.9917 73.5864 72.9937 73.5905 72.9978C100.605 53.5021 91.1278 26.914 91.1278 26.914C91.1278 26.914 63.2098 22.4474 48.915 52.514H48.9171Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1301 26.914C91.1301 26.914 100.607 53.5021 73.5928 72.9978C73.8762 73.0614 74.1596 73.1208 74.4471 73.1967C78.8827 74.3712 83.7003 76.8617 88.1422 80.5514C92.584 84.2411 95.9128 88.5149 97.876 92.6555C98.0054 92.9302 98.1163 93.2008 98.2354 93.4734C98.2682 93.4816 98.3031 93.4898 98.3381 93.498C100.248 92.0467 102.01 90.3864 103.587 88.4965C117.524 71.7762 111.951 44.2042 91.1321 26.914H91.1301Z",
    fill: "#8DAAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1333 32.2394C29.5669 33.4119 34.3866 35.9044 38.8284 39.5941C43.2682 43.2817 46.599 47.5576 48.5602 51.6982C48.6895 51.9709 48.8004 52.2435 48.9175 52.5161C63.2122 22.4495 91.1302 26.916 91.1302 26.916C70.3134 9.62793 42.1387 9.16877 28.2013 25.8891C26.6241 27.781 25.3078 29.8145 24.2256 31.9565C24.2359 31.9832 24.2502 32.0119 24.2625 32.0365C24.5521 32.102 24.8396 32.1615 25.1353 32.2414L25.1333 32.2394Z",
    fill: "#8DAAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1301 26.914L63.4873 60.0758C67.9271 63.7634 71.2538 68.0373 73.217 72.1759C73.3464 72.4505 73.4573 72.7211 73.5743 72.9937C73.5805 72.9937 73.5867 72.9958 73.5908 72.9999C100.605 53.5041 91.1281 26.9161 91.1281 26.9161L91.1301 26.914Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4328 73.1229L73.3835 72.9732L73.2911 72.7559C73.2069 72.5592 73.1248 72.3624 73.0303 72.1656C71.0219 67.9327 67.6007 63.6753 63.3909 60.1804C59.1832 56.6854 54.3676 54.1006 49.8334 52.8994C49.6239 52.8441 49.4206 52.799 49.2153 52.7539L48.7943 52.6596L48.6403 52.3009C48.554 52.0959 48.4657 51.893 48.3692 51.688C46.3629 47.4551 42.9417 43.1997 38.734 39.7048C34.5242 36.2078 29.7086 33.623 25.1744 32.4239C24.9629 32.3665 24.7534 32.3214 24.546 32.2742L24.1353 32.182L23.9648 31.7864C23.8827 31.5937 23.8005 31.401 23.7102 31.2083C21.7039 26.9755 18.2806 22.718 14.0729 19.2231C9.81176 15.6769 5.12145 13.1597 0.519448 11.9401L0.449627 11.9217L0.00195312 11.5486L0.0861487 11.4379C0.137487 11.3703 0.188826 11.3006 0.238111 11.2329C0.320253 11.1222 0.400342 11.0095 0.488645 10.9029C16.6357 -8.4678 57.3391 -1.33651 91.2206 26.8033C125.104 54.9431 139.53 93.5984 123.383 112.971C123.301 113.07 123.213 113.162 123.127 113.256C123.061 113.326 122.995 113.393 122.934 113.465L122.841 113.57L122.379 113.186L122.348 113.121C120.342 108.888 116.919 104.63 112.711 101.136C108.503 97.6406 103.686 95.0538 99.1494 93.8526C98.9338 93.7972 98.7223 93.7501 98.5107 93.703L98.1185 93.6107L97.9501 93.2192C97.868 93.0265 97.7859 92.8359 97.6934 92.6412C95.6851 88.4083 92.2639 84.1508 88.0561 80.6559C83.8484 77.161 79.0328 74.5741 74.4965 73.375C74.2604 73.3135 74.0283 73.2622 73.7963 73.211L73.439 73.1208L73.4328 73.1229ZM63.5737 59.961C67.8656 63.5256 71.3567 67.8671 73.4041 72.1861C73.5006 72.3911 73.5868 72.594 73.6731 72.7969L73.6957 72.8482C73.9298 72.8994 74.1639 72.9527 74.4021 73.0142C79.0287 74.238 83.9408 76.8761 88.2327 80.4407C92.5247 84.0053 96.0157 88.3468 98.0631 92.6657C98.1575 92.8646 98.2417 93.0634 98.328 93.2622L98.3567 93.3299L98.3978 93.3381C98.6155 93.3852 98.8352 93.4344 99.0591 93.4918C103.688 94.7176 108.6 97.3557 112.892 100.92C117.147 104.454 120.617 108.755 122.671 113.037C122.702 113.004 122.732 112.971 122.761 112.94C122.845 112.85 122.932 112.76 123.012 112.664C139.06 93.4119 124.718 54.9923 91.042 27.0226C57.3638 -0.947046 16.9088 -8.03939 0.860337 11.2145C0.774088 11.319 0.694 11.4277 0.615965 11.5363C0.597483 11.5629 0.579001 11.5875 0.558465 11.6142C5.14815 12.8543 10.0089 15.476 14.2598 19.0058C18.5517 22.5704 22.0427 26.9119 24.0901 31.2309C24.1846 31.4297 24.2688 31.6285 24.3529 31.8274L24.3796 31.893L24.4392 31.9053C24.6548 31.9524 24.8684 32.0016 25.0881 32.059C29.7127 33.2807 34.6228 35.9188 38.9188 39.4855C43.2107 43.0501 46.7017 47.3916 48.7471 51.7085C48.8477 51.9196 48.936 52.1307 49.0264 52.3419L49.0387 52.3726L49.1064 52.387C49.318 52.4341 49.5295 52.4813 49.7451 52.5387C54.3697 53.7624 59.2818 56.4005 63.5737 59.9631V59.961Z",
    fill: "#4C4D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4638 88.9556H52.4678V113.572H80.4638V88.9556Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8632 73.9715H39.0047L24.2314 91.809H41.8632V73.9715Z",
    fill: "#091644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8012 91.809H53.7783L55.5649 90.2634H85.3496L83.8012 91.809Z",
    fill: "#091644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0051 70.165L22.4453 90.3823L24.2319 91.8089L39.0051 73.9715L53.7784 91.8089L55.565 90.2634L39.0051 70.165Z",
    fill: "#333E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0049 70.165H68.7896L85.3494 90.2634H55.5647L39.0049 70.165Z",
    fill: "#091644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8525 90.2634L39.5661 74.6479L52.4973 90.2634V113.572H26.8525V90.2634Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6251 98.684H54.9795V106.654H65.6251V98.684Z",
    fill: "#CED6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0936 99.2148H55.5117V106.123H65.0936V99.2148Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0936 99.2148H55.5117V100.162H65.0936V99.2148Z",
    fill: "#091644"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.3887 106.121H57.2922L65.0937 102.49V102.07L56.3887 106.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M55.5117 105.012V106.121H55.8362L65.0936 101.812V100.551L55.5117 105.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6187 98.7126H59.9883V106.654H60.6187V98.7126Z",
    fill: "#CED6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1661 98.684H40.5205V106.654H51.1661V98.684Z",
    fill: "#CED6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6346 99.2148H41.0527V106.123H50.6346V99.2148Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6346 99.2148H41.0527V100.162H50.6346V99.2148Z",
    fill: "#091644"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.9297 106.121H42.8333L50.6347 102.49V102.07L41.9297 106.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.0527 105.012V106.121H41.3772L50.6346 101.812V100.551L41.0527 105.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1597 98.7126H45.5293V106.654H46.1597V98.7126Z",
    fill: "#CED6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.963 98.684H67.3174V106.654H77.963V98.684Z",
    fill: "#CED6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4315 99.2148H67.8496V106.123H77.4315V99.2148Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4315 99.2148H67.8496V100.162H77.4315V99.2148Z",
    fill: "#091644"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M68.7266 106.121H69.6301L77.4316 102.49V102.07L68.7266 106.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M67.8496 105.012V106.121H68.172L77.4315 101.812V100.551L67.8496 105.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9566 98.7126H72.3262V106.654H72.9566V98.7126Z",
    fill: "#CED6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2208 95.8512H30.1133V113.334H39.2208V95.8512Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1698 96.9008H31.1631V106.959H38.1698V96.9008Z",
    fill: "#889BD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1698 108.007H31.1631V112.633H38.1698V108.007Z",
    fill: "#889BD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6496 105.578C38.9388 105.578 39.1733 105.343 39.1733 105.055C39.1733 104.766 38.9388 104.532 38.6496 104.532C38.3604 104.532 38.126 104.766 38.126 105.055C38.126 105.343 38.3604 105.578 38.6496 105.578Z",
    fill: "#1D1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1698 96.9008H31.1631V98.147H38.1698V96.9008Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4962 105.174C38.6073 105.174 38.6974 105.084 38.6974 104.973C38.6974 104.862 38.6073 104.772 38.4962 104.772C38.385 104.772 38.2949 104.862 38.2949 104.973C38.2949 105.084 38.385 105.174 38.4962 105.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7752 83.8393H36.7666V91.809H41.7752V83.8393Z",
    fill: "#CED6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7735 84.3702H37.2988V91.2781H41.7735V84.3702Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7735 84.3702H37.2988V85.3173H41.7735V84.3702Z",
    fill: "#091644"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.7735 88.0845L37.2988 90.1671V91.2781H37.6212L41.7735 89.3451V88.0845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.7736 89.6034L38.1758 91.2781H39.0773L41.7736 90.0236V89.6034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4039 83.868H41.7734V91.809H42.4039V83.868Z",
    fill: "#CED6EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10001_9852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNafInsuranceHomeUmbrella);
export default __webpack_public_path__ + "static/media/naf-insurance-home-umbrella.7cd0d60fc19b4e504bfc3b6f711cb887.svg";
export { ForwardRef as ReactComponent };